import React, { useEffect, useState } from "react";
import { ClipboardCheck, RefreshCw, Search } from "lucide-react";
import { api } from "@/lib/api";
import LoadErrorBanner, { describeLoadError } from "@/components/admin/LoadErrorBanner";
import OnboardingProgressCard from "@/components/admin/OnboardingProgressCard";

// Live onboarding completion for a founding supplier (defaults to Setuply) — same verdict the stalled-nudge sweep uses.
export default function FoundingOnboardingCheck({ defaultQuery = "Setuply" }) {
  const [q, setQ] = useState(defaultQuery);
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const run = async (query) => {
    const term = (query ?? q).trim();
    if (!term) return;
    setBusy(true); setError(null);
    try { const { data } = await api.get(`/admin/onboarding/progress?q=${encodeURIComponent(term)}`); setItems(data.items || []); }
    catch (e) { setItems(null); setError(describeLoadError(e, "onboarding completion")); }
    finally { setBusy(false); }
  };
  useEffect(() => { run(defaultQuery); }, [defaultQuery]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="bg-white border border-[#E8ECE9] p-5" data-testid="founding-onboarding-check">
      <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
        <div>
          <div className="font-serif text-lg text-[#11211A] flex items-center gap-2"><ClipboardCheck className="w-4 h-4 text-[#264839]" /> Onboarding completion · {defaultQuery}</div>
          <p className="text-xs text-[#7D8C85] mt-0.5">Live from the database right now — the exact checklist and signals the stalled-onboarding sweep evaluates, plus what it saw when it emailed.</p>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); run(); }} className="flex items-center gap-2">
          <div className="relative">
            <Search className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-[#9AA6A0]" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Company or email" className="pl-8 pr-3 py-1.5 text-sm border border-[#C4CFC9] rounded-sm w-56" data-testid="founding-onboarding-input" />
          </div>
          <button type="submit" disabled={busy || !q.trim()} className="btn-ghost text-xs disabled:opacity-50" title="Refresh" data-testid="founding-onboarding-refresh"><RefreshCw className={`w-3.5 h-3.5 ${busy ? "animate-spin" : ""}`} /> {busy ? "Checking…" : "Check"}</button>
        </form>
      </div>
      <LoadErrorBanner error={error} onRetry={() => run()} testId="founding-onboarding-error" />
      {items && items.length === 0 && <div className="text-xs text-[#7D8C85]" data-testid="founding-onboarding-empty">No supplier matches "{q}".</div>}
      {items?.map((s) => <OnboardingProgressCard key={s.id} s={s} />)}
    </div>
  );
}
